import { YieldFetcher } from '../../types'

const RETH_URL = 'https://api.rocketpool.net/api/mainnet/payload'

export const rethFetcher: YieldFetcher = {
  label: 'RETH',
  fetch: async () => {
    const res = await fetch(RETH_URL).then((r) => r.json())
    return { RETH: Number(res.rethAPR) }
  },
}
